import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CheckupFeedbackComponent } from './checkup-feedback.component';

const routes: Routes = [{ path: '', component: CheckupFeedbackComponent }];

export const routing: ModuleWithProviders<any> = RouterModule.forChild(routes);
